import React from 'react';

import { getAppConstants } from '#/config/appConstants';
import { getMockFile } from '#/hooks/useUpload/getMockFile';

import type { ImagePickerDropzoneProps } from './ImagePickerDropzoneInternal';
import { ImagePickerDropzoneInternal } from './ImagePickerDropzoneInternal';

export function ImagePickerDropzone(props: ImagePickerDropzoneProps) {
  const { onDrop, ...restProps } = props;

  const isFilestackMock = getAppConstants().filestackMockEnabled;

  const getDroppedFile = isFilestackMock
    ? getMockFile
    : (e: React.DragEvent) => Promise.resolve(e.dataTransfer.files[0]);

  const triggerClick = isFilestackMock
    ? async (e: React.UIEvent) => {
        e.preventDefault();
        onDrop(await getMockFile());
      }
    : (e: React.UIEvent, fileInput: HTMLInputElement) => {
        e.preventDefault();
        fileInput.click();
      };

  return (
    <ImagePickerDropzoneInternal
      // oxlint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
      onDrop={onDrop}
      getDroppedFile={getDroppedFile}
      triggerClick={triggerClick}
    />
  );
}
